export default "__VITE_ASSET__xJuYrWiq__"